var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base-input-number" },
    [
      _c(
        "label",
        {
          staticClass: "base-input-number__label cl-mine-shaft flex",
          attrs: { for: _vm.getInputId }
        },
        [_vm._v(_vm._s(_vm.name) + ": ")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.inputValue,
            expression: "inputValue"
          }
        ],
        staticClass:
          "m0 no-outline base-input-number__input brdr-cl-primary bg-cl-transparent h4 width_rwd",
        attrs: {
          id: _vm.getInputId,
          type: "number",
          min: _vm.min,
          max: _vm.max,
          disabled: _vm.disabled,
          focus: _vm.autofocus
        },
        domProps: { value: _vm.inputValue },
        on: {
          blur: function($event) {
            return _vm.$emit("blur", $event.target.value)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.inputValue = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _vm.validations
        ? _c("ValidationMessages", { attrs: { validations: _vm.validations } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }